import axios from 'axios';
import CustomSelect from '../form/custom-select';
import {initFlatTicket} from '../../common/scripts/common';
import Observer from '../../common/scripts/observer';
import tmplFlatsList from './templates/favorites-list.twig';
import {Utils} from '../../common/scripts/utils';

const observer = new Observer();

class FavoritesList {
    constructor() {
        /**
         * Обёртка блока с избранным
         */
        this.wrapper = null;

        /**
         * Адрес запросов
         * @type {string}
         */
        this.action = '';

        /**
         * Обёртка для списка квартир
         */
        this.contentWrapper = null;

        /**
         * Обёртка селекта с сортировкой квартир
         */
        this.selectSortWrapper = null;

        /**
         * Селект с сортировкой квартир
         */
        this.selectSort = null;

        /**
         * Кнопка для показа/скрытия забронированных квартир
         */
        this.buttonLock = null;

        /**
         * Блок для вывода количества
         */
        this.resultCount = null;

        /**
         * Скрывать/не скрывать забронированные квартиры
         * @type {boolean}
         */
        this.isHideLocked = false;

        /**
         * Класс который добавляется при подгрузке
         * @type {string}
         */
        this.loadingClass = 'is-loading';

        /**
         * Тип запроса
         * @type {string}
         */
        this.requestType = '';
    }

    /**
     * Инициализация
     * @param {object} options - параметры
     */
    init(options) {
        this.wrapper = options.wrapper;

        this._getElements();
        this._initSelect();
        this._bindEvents();
        this._initBooked();
    }

    /**
     * Получение дом-элементов
     * @private
     */
    _getElements() {
        this.action = this.wrapper.dataset.action || '/tests/favorites.json';
        this.contentWrapper = this.wrapper.querySelector('.j-favorite-list-content');
        this.selectSortWrapper = this.wrapper.querySelector('.j-favorite-filter-sort');
        this.buttonLock = this.wrapper.querySelector('.j-favorite-filter-lock');
        this.resultCount = this.wrapper.querySelector('.j-favorite-filter-count');
        this.filter = this.wrapper.querySelector('.j-favorite-filter');
        this.st = this.filter.dataset.appendSt || null;
        this.ts = this.filter.dataset.appendTs || null;
    }

    /**
     * Инициализация селект
     * @private
     */
    _initSelect() {
        if (!this.selectSortWrapper) {
            return;
        }

        this.selectSort = new CustomSelect({
            elem: this.selectSortWrapper
        });

        this.selectSort.init();
    }

    /**
     * Навешивает обработчики событий
     * @private
     */
    _bindEvents() {
        if (!this.selectSortWrapper) {
            return;
        }

        this.selectSortWrapper.addEventListener('change', () => {
            this.requestType = 'sort';
            this._send();
        });
    }

    /**
     * Инициализация кнопки показать/скрыть забронированные
     * @private
     */
    _initBooked() {
        if (!this.buttonLock) {
            return;
        }

        this.hideStateId = this.buttonLock.dataset.hideState || 2;

        const bookedButtonTooltip = this.buttonLock.querySelector('.j-button__tooltip');

        this.buttonLock.addEventListener('click', () => {
            this.buttonLock.classList.toggle('is-hide');

            this.isHideLocked = this.buttonLock.classList.contains('is-hide');
            this.requestType = 'filter';

            this._send();

            bookedButtonTooltip.innerText = this.isHideLocked ? 'Показать забронированные' : 'Скрыть забронированные';
        });
    }

    /**
     * Отправляет запрос
     * @private
     */
    _send() {
        this.formData = this._collectData();

        this._toggleLoading(true);

        axios.post(this.action, this.formData)
            .then((response) => {
                const success = response.data.success;

                if (success) {
                    this.data = response.data.data;

                    this._setTemplateData();
                } else {
                    throw new Error('Ошибка на сервере');
                }
            })
            .catch((err) => {
                console.error(err);
            })
            .finally(() => {
                this._toggleLoading(false);
            });
    }

    /**
     * Собирает данные для отправки
     * @return {queryData} - объект данных для гет запроса
     * @private
     */
    _collectData() {
        const formData = new FormData();
        const options = this.selectSort.getOptions();
        const activeSelect = options.find((item) => {
            return item.checked;
        });

        formData.append('requestType', this.requestType);
        formData.append('sort', activeSelect.value);
        formData.append('hideState', this.isHideLocked ? 1 : 0);
        formData.append('st', this.st);
        formData.append('ts', this.ts);

        return formData;
    }

    /**
     * Устанавливает данные в шаблон
     * @private
     */
    _setTemplateData() {
        const {flats, total} = this.data;

        this.resultCount.innerText = total;

        // Конвертируем стоимость
        flats.forEach((item) => {
            item.isFavoritePage = true;
            item.price.current = Utils.convertToDigit(item.price.current);

            if (item.price.mortgage) {
                item.price.mortgage = Utils.convertToDigit(item.price.mortgage);
            }
        });

        Utils.clearHtml(this.contentWrapper);
        Utils.insetContent(this.contentWrapper, tmplFlatsList({flats}));

        // initFlatCardOptions();
        initFlatTicket();
        observer.publish('favorite:reInit');
    }

    /**
     * Показывает/скрывает загрузку
     * @param {boolean} show - показать/скрыть
     * @private
     */
    _toggleLoading(show) {
        const method = show ? 'add' : 'remove';

        this.wrapper.classList[method](this.loadingClass);
    }
}

export default FavoritesList;
